import { render, staticRenderFns } from "./protect-sidebar.vue?vue&type=template&id=337b5268&scoped=true&"
import script from "./protect-sidebar.vue?vue&type=script&lang=js&"
export * from "./protect-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./protect-sidebar.vue?vue&type=style&index=0&id=337b5268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b5268",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default,ProtectFooter: require('/opt/build/repo/storefront/components/legacy/protect/protect-footer.vue').default})
